import React from 'react';
import classNames from 'classnames';
import styled from 'styled-components';
import MenuPopover from '../../components/menu-popover';
import Text from '../../components/text';
import { colors, spacing } from '../../style';

interface NotificationItemProps {
  type?: string;
  children?: React.ReactNode;
  onClick?: React.HTMLProps<HTMLDivElement>['onClick'];
  id?: string | number;
  className?: string;
}

const NotificationItemStyled = styled.div`
  padding: ${spacing.xs};
  border-radius: ${spacing.xxs};
  cursor: pointer;

  &:hover,
  &.active,
  [data-highlighted] & {
    background: ${colors.gray100};
  }

  &:active {
    background: ${props => props.theme.actionLight};
  }
`;

const NotificationItem = ({ id, type, onClick, children, className, ...rest }: NotificationItemProps) => {
  return (
    <MenuPopover.CleanItem>
      <NotificationItemStyled
        className={classNames('notification-item', className)}
        data-id={id}
        data-value={type}
        onClick={onClick}
        {...rest}
      >
        <Text align={'left'} size={'md'}>
          {children}
        </Text>
      </NotificationItemStyled>
    </MenuPopover.CleanItem>
  );
};

export default NotificationItem;
